module.exports = __webpack_public_path__ + "img/maritalStatus.57095c71.svg";